import { __ } from './i18n.js';

const ERROR_CODES = {
    400: {
        code: "BAD_REQUEST",
        message: __("Hibás kérés!")
    },
    401: {
        code: "UNAUTHORIZED",
        message: __("Nem engedélyezett kérés!")
    },
    402: {
        code: "PAYMENT_REQUIRED",
        message: __("Fizetés szükséges!")
    },
    403: {
        code: "FORBIDDEN",
        message: __("Hozzáférés megtagadva!")
    },
    404: {
        code: "NOT_FOUND",
        message: __("Az adott elem nem található!")
    },
    408: {
        code: "REQUEST_TIMEOUT",
        message: __("A művelet időtúllépés miatt sikertelen!")
    },
    409: {
        code: "CONFLICT",
        message: __("A művelet ütközést okozott!")
    },
    410: {
        code: "GONE",
        message: __("Az elem már nem található!")
    },
    411: {
        code: "LENGTH_REQUIRED",
        message: __("A tartalom hossza kötelező!")
    },
    412: {
        code: "PRECONDITION_FAILED",
        message: __("Az előfeltétel nem teljesült!")
    },
    413: {
        code: "PAYLOAD_TOO_LARGE",
        message: __("A payload túl nagy!")
    },
    414: {
        code: "URI_TOO_LONG",
        message: __("Az URI túl hosszú!")
    },
    415: {
        code: "UNSUPPORTED_MEDIA_TYPE",
        message: __("Nem támogatott média típus!")
    },
    416: {
        code: "RANGE_NOT_SATISFIABLE",
        message: __("A tartomány nem kielégíthető!")
    },
    417: {
        code: "EXPECTATION_FAILED",
        message: __("A várt eredmény elmaradt!")
    },
    428: {
        code: "PRECONDITION_REQUIRED",
        message: __("Az előfeltétel szükséges!")
    },
    429: {
        code: "TOO_MANY_REQUESTS",
        message: __("Túl sok kérés érkezett!")
    },
    431: {
        code: "REQUEST_HEADER_FIELDS_TOO_LARGE",
        message: __("A kérés fejléc mezői túl nagyok!")
    },
    500: {
        code: "INTERNAL_SERVER_ERROR",
        message: __("Belső szerverhiba történt!")
    },
    501: {
        code: "NOT_IMPLEMENTED",
        message: __("A funkció még nincs implementálva!")
    },
    503: {
        code: "SERVICE_UNAVAILABLE",
        message: __("A szolgáltatás nem elérhető!")
    },
    504: {
        code: "GATEWAY_TIMEOUT",
        message: __("Időtúllépés történt a kapu-nál!")
    },
    510: {
        code: "NOT_EXTENDED",
        message: __("A kérés nem bővíthető!")
    },
    511: {
        code: "NETWORK_AUTHENTICATION_REQUIRED",
        message: __("A hálózati hitelesítés szükséges!")
    }
};

export { ERROR_CODES };
//# sourceMappingURL=http.data.js.map
